export const HAS_OPACITY_CLASS = "has-opacity";
export const IS_HIGHLIGHTED_CLASS = "hero__salon--highlighted";
export const VANISHED_CLASS = "vanished";
export const HEADER_MENU_CLASS = "header--menu-active";
export const MENU_ACTIVE_CLASS = "menu--active";
export const HAMBURGER_ACTIVE_CLASS = "hamburger--open";
